import { useAuthDetails } from '../../LoggedIn/ProviderContext';

export const useProviderId = () => {
  const { providerId } = useAuthDetails();
  return { providerId };
};
